import { Configuration } from "../lib-api";
export const ApiConfiguration = new Configuration({
    basePath: window.location.protocol + "//" + window.location.host
}); 